import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';
import { AppConfig } from 'src/app/config/config';
import { Route } from '@angular/router';

@Injectable({
  providedIn: 'root'
})
export class RouteService {
  private pathApi = this.config.setting['pathApi'] + "route/";

  constructor(private http: HttpClient, private config: AppConfig) { }

  get(id: any): Observable<any> {
    return this.http.get(`${this.pathApi}${id}`);
  }
  
  getAll(obj: any): Observable<any> {
    return this.http.post(`${this.pathApi}getAll`, obj);
  }

  getAllForDistrict(districtId: number): Observable<any> {
    return this.http.get(`${this.pathApi}getAllForDistrict/${districtId}`);
  }

  save(obj: Route): Observable<any> {
    return this.http.post(`${this.pathApi}save`, obj);
  }

  delete(id: number): Observable<any> {
    return this.http.delete(`${this.pathApi}delete/${id}`);
  } 

  uploadFile(obj: any): Observable<any> {
    return this.http.post(`${this.pathApi}uploadFile`, obj);
  }

  getTemplate(): Observable<any>{
    return this.http.get(`${this.pathApi}getTemplate`);
  }

  getRouteForOptionsByDistrict(districtId: any = null): Observable<any> {
    if(districtId)
      return this.http.get(`${this.pathApi}getRouteForOptionsByDistrict?districtId=${districtId}`);
    else
      return this.http.get(`${this.pathApi}getRouteForOptionsByDistrict`);
  }

  getRoutesForOptions(): Observable<any> {
    return this.http.get(`${this.pathApi}getRoutesForOptions`);
  }

}
